import { KameleoonStorageKey } from 'src/storage';
import { TargetingType } from 'src/targeting';
import { KameleoonException } from './types';

export const ERROR_MESSAGES = {
  [KameleoonException.CookieParse]: (reason: string) =>
    `Couldn't parse cookie string: ${reason}`,
  [KameleoonException.JSONParse]: (err: unknown) =>
    `Couldn't parse JSON variable: ${err}`,
  [KameleoonException.NumberParse]: (value: string) =>
    `It's not possible to parse value ${value} to Number`,
  [KameleoonException.VersionParse]: (value: string) =>
    `It's not possible to parse a version value ${value} to Number, version should be in format x.x`,
  [KameleoonException.SemanticVersionParse]: (value: string) =>
    `It's not possible to parse a version value ${value} to Number, version should be in format x.x.x`,
  [KameleoonException.Initialization]: () =>
    "It seems that the client wasn't properly initialized, make sure to run `initialize` method before invoking other methods",
  [KameleoonException.Credentials]: () =>
    'KameleoonClient can not be created without credentials',
  [KameleoonException.StorageInitialization]: () =>
    "There was an error while initializing React Native SDK storage, it seems that the storage library dependency wasn't installed",
  [KameleoonException.EventSourceInitialization]: () =>
    "There was an error while initializing Real Time Update service, it seems that the event source library dependency wasn't installed",
  [KameleoonException.FeatureFlagConfigurationNotFound]: (featureKey: string) =>
    `No feature flag with key ${featureKey} was found.`,
  [KameleoonException.FeatureFlagEnvironmentDisabled]: (
    featureKey: string,
    environment: string,
  ) =>
    `Feature flag with key ${featureKey} is disabled in ${environment} environment.`,
  [KameleoonException.FeatureFlagVariableNotFound]: (
    variableKey: string,
    visitorCode: string,
  ) =>
    `No feature flag variable with key ${variableKey} was found for ${visitorCode} visitorCode.`,
  [KameleoonException.FeatureFlagVariationNotFound]: (
    variationKey: string,
    visitorCode: string,
  ) =>
    `No feature flag variation with key ${variationKey} was found for ${visitorCode} visitorCode.`,
  [KameleoonException.FeatureFlagExperimentNotFound]: (
    experimentId: number,
    visitorCode: string,
  ) =>
    `No feature flag experiment with id ${experimentId} was found for ${visitorCode} visitorCode.`,
  [KameleoonException.VisitAmount]: () =>
    'Visit amount must be a number between 1 and 25',
  [KameleoonException.VisitorCodeMaxLength]: () =>
    'Visitor code can not be more than 255 characters long',
  [KameleoonException.VisitorCodeEmpty]: () => 'Visitor code can not be empty',
  [KameleoonException.StorageWrite]: (err: unknown) =>
    `Couldn't update storage for kameleoonClient: ${err}`,
  [KameleoonException.StorageRead]: (key: KameleoonStorageKey) =>
    `No data found in storage under ${key} key`,
  [KameleoonException.StorageEmpty]: () => 'No data found in storage',
  [KameleoonException.StorageParse]: (err: unknown, key: KameleoonStorageKey) =>
    `Couldn't parse ${key} storage data, the data may be corrupted. Error: ${err}`,
  [KameleoonException.ClientConfiguration]: (err: unknown) =>
    `Couldn't retrieve client configuration from Kameleoon Api. Error: ${err}`,
  [KameleoonException.TargetingCondition]: (targetingType: TargetingType) =>
    `${targetingType} targeting condition is not yet supported.`,
  [KameleoonException.AmongValuesCheck]: (err: unknown, value: string) =>
    `Couldn't parse value "${value}": ${err}`,
  [KameleoonException.RangeCheck]: (value?: number[] | null) =>
    `Couldn't parse value "${value}" as a range, value should be in format [x: number, y: number]`,
  [KameleoonException.RemoteData]: (err: unknown) =>
    `Couldn't retrieve data from Kameleoon server. Error: ${err}`,
  [KameleoonException.MaximumRetriesReached]: (err: unknown) =>
    `Maximum retries reached, request failed. Reason: ${err}`,
};
